export default __webpack_public_path__ + "static/media/SettingsIcon.a6fb3405.svg";